export const SvgIcon = {
  alert: 'alert',
  area: 'area',
  bathtub: 'bathtub',
  bed: 'bed',
  email: 'email',
  favicon: 'fav_icon',
  location: 'location_icon',
  message: 'message',
  notification: 'notification',
  phone: 'phone',
  trash: 'trash',
  upload: 'upload',
  wishfill: 'wish_fill',
  removed_prop: 'removed-property',
  updateImage: 'update_image',
  star: 'star',
  chatMessage: 'chat-message',
  arrow_left: 'arrow_left',
  arrow_right: 'arrow_right',
  download: 'download',
  tooltip: 'tooltip'
} as const;
